// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mx-auto[data-v-b778f87c]{margin:auto}.v-data-table[data-v-b778f87c] .v-data-table-header{background-color:green}.v-data-table[data-v-b778f87c] .v-data-table-header tr th span{color:#e0e0e0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
